/* eslint-disable @typescript-eslint/naming-convention */

import type { BacklinksSummaryTopCountry } from "@similarweb/pro-api-client";

import CountryService from "app/services/CountryService";

type Country = { code: string; id: number };

export const getConvertedTopCountriesData = (topCountriesData: BacklinksSummaryTopCountry[], limitItems = 5) => {
    const calculatedRefDomainsCount = topCountriesData.reduce((acc, curr) => acc + curr.Count, 0);

    return topCountriesData
        .map((countryData) => ({
            ...countryData,
            CountryID: ((CountryService.countries as Country[]) ?? []).find((c) => {
                return c.code.toLowerCase() === countryData.Country.toLowerCase();
            })?.id,
            RefDomainsShare: calculatedRefDomainsCount ? countryData.Count / calculatedRefDomainsCount : 0,
        }))
        .filter((countryData) => countryData.CountryID)
        .slice(0, limitItems);
};

export const getChangeValue = (previousValue: number, currentValue: number): number => {
    if (!currentValue || !previousValue) {
        return 0;
    }

    return (currentValue - previousValue) / previousValue;
};
